export default {"src":"/_next/static/media/aq.b1cbfff8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};